module.exports = __webpack_public_path__ + "static/media/resume.6a8ce785.pdf";